<template>
  <v-container>
    <v-card elevation="0" outlined>
      <v-card-title>{{ store.name }}</v-card-title>
      <v-card-text class="d-flex flex-wrap justify-space-between">
        <v-container col-2 v-for="product in products" :key="product.id">
          <product-card :product="product"></product-card>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import backendService from "@/services/backend-service";
import eventBus from "@/js/event-bus";
//import GeneralSnackbar from "@/components/GeneralSnackbar.vue";
import ProductCard from "@/components/ProductCard.vue";
export default {
  name: "CategoryPage",
  mounted: function () {
    this.getProductsByCategoryId(this.$route.params.id);
  },
  components: {
    //"general-snackbar": GeneralSnackbar,
    "product-card": ProductCard,
  },
  data() {
    return {
      products: [],
      store: {},
      isLoadingIdx: -1,
      isLoading: false,
    };
  },
  computed: {
    cart() {
      return this.$store.getters["cart"];
    },
    cartCount() {
      return this.$store.getters["cartCount"];
    },
  },
  methods: {
    addToCart(product) {
      let cart = this.cart;
      let cartCount = this.cartCount;
      if (!cart[product.id]) {
        let item = { product: product, count: 0 };
        cart[product.id] = item;
      }
      cart[product.id].count += 1;
      this.$store.commit("setCart", cart);
      this.$store.commit("setCartCount", cartCount + 1);

      localStorage.setItem("cartCount", cartCount + 1);
      localStorage.setItem("cart", JSON.stringify(cart));
      this.isLoadingIdx = product.id;
      this.timer(1000).then(() => {
        this.isLoadingIdx = -1;
        eventBus.$emit(
          "setSnackbar",
          "Item added to the cart",
          "success",
          true
        );
      });
    },
    getProductsByCategoryId(categoryId) {
      backendService.getProductsByCategoryId(categoryId).then((response) => {
        this.products = response.data;
      });
    },
  },
};
</script>
